module.exports = __webpack_public_path__ + "img/Cookie_1_resize_26.70d9569c.png";